import { LoadingFallback as _LoadingFallback } from "~/components/product/ProductShelf"

export { default, loader } from "~/components/product/ProductShelf"

export const LoadingFallback = _LoadingFallback
